import React, { Component } from "react";
import InputMask from "react-input-mask";

import { hotjar } from "react-hotjar";
import { store } from "app/store";

import { Icon } from "app/NativeComponents/common";

class Input extends Component {
  handleKeyPress(ev, onSubmitEditing) {}

  renderIcon() {
    if (this.props.icon) {
      if (this.props.icon == "blank") {
        return (
          <div
            className="flex-item"
            style={{
              width: 80,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            &nbsp;
          </div>
        );
      }

      const colors = store.getState().settings.colors;

      return (
        <div
          className="flex-item"
          style={{ width: 80, alignItems: "center", justifyContent: "center" }}
        >
          <Icon icon={this.props.icon} color={colors.text_color} size={28} />
        </div>
      );
    }
  }

  render() {
    const {
      size,
      name,
      placeholder,
      value,
      type,
      onChange,
      onSubmitEditing = null,
      className,
      mask,
      stripe,
      editable = true,
      onFocus = () => {},
      onBlur = () => {},
      maxlength = null
    } = this.props;
    var val = value;
    if (!val) {
      val = "";
    }

    const colors = store.getState().settings.colors;

    return (
      <div
        className={
          size === "small"
            ? "dm-input small flex-item left-flex"
            : "dm-input flex-item left-flex"
        }
      >
        {this.renderIcon()}
        <div style={{ flex: 1 }}>
          <div
            className={
              val.length > 0 && value != null
                ? "floating-label active animated fadeInUp"
                : "floating-label animated fadeOutDown"
            }
          >
            <label
              style={{
                color: colors.light_text_color
              }}
            >
              {placeholder}
            </label>
          </div>
          <div>
            <InputMask
              name={name}
              readOnly={!editable}
              className={val.length > 0 ? "active " + className : className}
              style={{
                color: colors.text_color
              }}
              type={type}
              onChange={ev => onChange(ev.target.value)}
              onKeyPress={ev => this.handleKeyPress(ev, onSubmitEditing)}
              value={value}
              placeholder={placeholder}
              autoComplete="off"
              mask={mask}
              alwaysShowMask={false}
              maskChar=" "
              data-stripe={stripe}
              onFocus={onFocus}
              onBlur={onBlur}
              maxLength={maxlength}
            />
          </div>
        </div>
      </div>
    );
  }
}
export { Input };
